import React from "react"
import Fade from "react-reveal/Fade"
import CustomPopup from './popup.js'

const Card = ({ heading, paragraph, imgUrl, projectLink, isLink }) => {
  return (
    <div
      className="card"
      style={{
        backgroundImage:
          "linear-gradient(to bottom, rgba(255, 255, 255, 0.3), rgba(0, 0, 0, 0.7)),url(" +
          imgUrl +
          ")",
      }}
    >
        <Fade cascade>
      <div className="content">
        <h1 className="header">{heading}</h1>
        <p className="text">{paragraph}</p>
        <CustomPopup url={projectLink} isLink={isLink}/>
      </div>
      </Fade>
    </div>
  )
}

export default Card
